<template>
  <poi-block :poi="note.poi" :show-distance="false">
    <div class="note-container" role="presentation">
      <div class="note-header">Your notes:</div>
      <div class="note-text">{{ note.text }}</div>
    </div>
  </poi-block>
</template>

<script>
import PoiBlock from '@/components/PoiBlock'

export default {
  name: 'NoteBlock',
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  components: {
    PoiBlock
  },
  computed: {
    poi: function () {
      return this.note.poi
    }
  }
}
</script>

<style lang="stylus">
  .build-wrapper
    .slot-content
      .note-container
        padding 8px
        .note-header
          font-weight bold
          text-decoration underline
          margin-bottom 0.5em
</style>
